import { useState } from "react";
import { useToast } from "@chakra-ui/react";
import { useApiRequest } from "../../../hooks/useApiRequest";
import { settings } from "../../../shared/settings";
import { useProcessHubFormsData } from "./ProcessHubFormsContext";
import type { FormType } from "./types";

const base = () => settings.environment.VITE_PROCESS_HUB_BASE_URL ?? "";

export function useProcessHubForms() {
  const toast = useToast();
  const { request } = useApiRequest();
  const { forms, loading, error, refresh, patchForm } = useProcessHubFormsData();

  const [isFormModalOpen, setIsFormModalOpen] = useState(false);
  const [isFieldsDrawerOpen, setIsFieldsDrawerOpen] = useState(false);
  const [selectedForm, setSelectedForm] = useState<FormType | null>(null);

  const handleToggleActive = async (form: FormType) => {
    try {
      await request({
        url: `${base()}/api/v1/forms/${form.id}`,
        method: "PATCH",
        payload: { is_active: !form.is_active },
        skipToast: true,
      });
      patchForm(form.id, { is_active: !form.is_active });
    } catch {
      toast({ title: "Erro ao alterar status do formulário", status: "error", duration: 4000, isClosable: true });
    }
  };

  const handleCreateOpen = () => {
    setSelectedForm(null);
    setIsFormModalOpen(true);
  };

  const handleEditOpen = (form: FormType) => {
    setSelectedForm(form);
    setIsFormModalOpen(true);
  };

  const handleManageFields = (form: FormType) => {
    setSelectedForm(form);
    setIsFieldsDrawerOpen(true);
  };

  return {
    forms,
    loading,
    error,
    isFormModalOpen,
    setIsFormModalOpen,
    isFieldsDrawerOpen,
    setIsFieldsDrawerOpen,
    selectedForm,
    handleCreateOpen,
    handleEditOpen,
    handleManageFields,
    handleToggleActive,
    refreshList: refresh,
  };
}